import './styles.scss';
import { KeyboardTabOutlined, KeyboardBackspaceOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useCallback, useContext } from 'react';

import { PortfolioManagementContext } from '../../../providers/portfolio-management';

import { PortfolioSidebarContent } from './portfolio-sidebar-content';

type PortfolioSidebarProps = {
  isPortfolioSidebarOpen: boolean;
  setIsPortfolioSidebarOpen: (value: boolean) => void;
};

export const PortfolioSidebar = ({
  isPortfolioSidebarOpen,
  setIsPortfolioSidebarOpen,
}: PortfolioSidebarProps) => {
  const { isPortfolioSidebarSettingsOpen, setIsPortfolioSidebarSettingsOpen } = useContext(
    PortfolioManagementContext,
  );

  const handlePortfolioSidebarOpen = useCallback(() => {
    setIsPortfolioSidebarOpen(true);
  }, []);

  const handlePortfolioSidebarClose = useCallback(() => {
    setIsPortfolioSidebarOpen(false);

    if (isPortfolioSidebarSettingsOpen) {
      setIsPortfolioSidebarSettingsOpen(false);
    }
  }, [isPortfolioSidebarSettingsOpen]);

  return (
    <div className="portfolio-sidebar-container">
      <div
        className={`portfolio-sidebar-nav ${isPortfolioSidebarOpen ? 'portfolio-sidebar-open' : 'portfolio-sidebar-close'}`}
        role="navigation"
        aria-hidden={!isPortfolioSidebarOpen}
      >
        <div className="portfolio-sidebar-header">
          {isPortfolioSidebarOpen && (
            <h2 className="portfolio-sidebar-header-title">Account selection</h2>
          )}

          <div className={`portfolio-sidebar-button-${isPortfolioSidebarOpen ? 'close' : 'open'}`}>
            <Button
              onClick={
                isPortfolioSidebarOpen ? handlePortfolioSidebarClose : handlePortfolioSidebarOpen
              }
            >
              {isPortfolioSidebarOpen ? <KeyboardBackspaceOutlined /> : <KeyboardTabOutlined />}
            </Button>
          </div>
        </div>
        <div className="portfolio-sidebar-content">
          <PortfolioSidebarContent isPortfolioSidebarOpen={isPortfolioSidebarOpen} />
        </div>
      </div>
    </div>
  );
};
